import compose from 'utils/composeEnhancer'
import handleSidebarStore from './handleSidebarStore'
import handleFeedbackStore from 'hooks/handleFeedbackStore'

export default compose(handleSidebarStore, handleFeedbackStore)
